const setupStickyHeader = () => {
  const header = document.getElementById('header');

  document.addEventListener('scroll', function () {

    if (window.scrollY > header.offsetHeight) {
      header.classList.add('sticky');
    }
    if (window.scrollY === 0) {
      header.classList.add('fade-out')
      header.classList.remove('sticky')

      setTimeout(() => {
        header.classList.remove('fade-out');
      }, 400);
    }
  });
};

export default setupStickyHeader;
